exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'blogpost') return `/blog/${doc.uid}/`
  if (doc.type === 'product') return `/private-treaty/${doc.uid}/`
  if (doc.type === 'case_study') return `/case-studies/${doc.uid}/`
  return '/'
}
